import React, { useRef, useState, useEffect } from "react";

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  className?: string;
}

// const TruncatedTextWithTooltip: React.FC<TruncatedTextProps> = ({
//   text,
//   maxLength = 40,
//   className = "",
// }) => {
//   const textRef = useRef<HTMLSpanElement>(null);
//   const [isTruncated, setIsTruncated] = useState(false);
//   const [showTooltip, setShowTooltip] = useState(false);

//   useEffect(() => {
//     if (textRef.current) {
//       // Check if text content exceeds the maxLength
//       const isOverflowing = text.length > maxLength;
//       setIsTruncated(isOverflowing);
//     }
//   }, [text, maxLength]);

//   const handleMouseEnter = () => {
//     if (isTruncated) {
//       setShowTooltip(true);
//     }
//   };

//   const handleMouseLeave = () => {
//     setShowTooltip(false);
//   };

//   const displayText = isTruncated ? `${text.substring(0, maxLength)}...` : text;

//   return (
//     <div
//       style={{ position: "relative", display: "inline-block", zIndex: 9999, }}
//     >
//       <span
//         ref={textRef}
//         className={className}
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         style={{
//           cursor: isTruncated ? "pointer" : "default",
//           display: "inline-block",
//           maxWidth: "100%",
//         }}
//       >
//         {displayText}
//       </span>

//       {showTooltip && (
//         <div
//           style={{
//            position: "absolute",
//             top: "-25px", // show above
//             left: "50%",
//             transform: "translateX(-50%)",
//             background: "#333",
//             color: "#fff",
//             padding: "5px 8px",
//             borderRadius: "4px",
//             whiteSpace: "normal",
//             width: "200px",
//             zIndex: 99999, // ensure it’s above everything
//             fontSize: "12px",
//             boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
//           }}
//         >
//           {text}
//           <div
//             style={{
//               position: "absolute",
//               top: "100%",
//               left: "50%",
//               transform: "translateX(-50%)",
//               borderWidth: "4px",
//               borderStyle: "solid",
//               borderColor:
//                 "rgba(0, 0, 0, 0.85) transparent transparent transparent",
//             }}
//           />
//         </div>
//       )}
//     </div>

//   );
// };
const TruncatedTextWithTooltip: React.FC<TruncatedTextProps> = ({
  text,
  maxLength = 25,
  className,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const truncated =
    text.length > maxLength ? text.slice(0, maxLength) + "…" : text;

  return (
    <div
      className={className}
      style={{
        position: "relative",
        display: "inline-block",
        maxWidth: "100%",
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {truncated}
      </span>

      {showTooltip && text.length > maxLength && (
        <div
          style={{
            position: "absolute",
            top: "-15px", // show above
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "#fff",
            padding: "5px 8px",
            borderRadius: "4px",
            whiteSpace: "normal",
            minWidth: "200px",
            zIndex: 99999, // ensure it’s above everything
            fontSize: "12px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          {text}
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              borderWidth: "4px",
              borderStyle: "solid",
              borderColor:
                "rgba(0, 0, 0, 0.85) transparent transparent transparent",
            }}
          />
        </div>
      )}
    </div>
  );
};
export default TruncatedTextWithTooltip;
